var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5125_30004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8315 0.0898438C9.70141 0.0898445 10.334 4.48284 10.334 4.48284L10.3453 9.03394H20.0121V10.4004H6.50565C6.50565 10.4004 0.0234375 9.66526 0.0234375 19.8866C0.0234368 30.1079 5.68126 29.7454 5.68126 29.7454H9.05788V25.0023C9.05788 25.0023 8.87587 19.3445 14.6254 19.3445H24.2132C24.2132 19.3445 29.5999 19.4316 29.5999 14.1384V5.38629C29.5999 5.38628 30.4178 0.0898438 19.8315 0.0898438ZM14.5011 3.15026C15.4629 3.15026 16.2403 3.92761 16.2403 4.88939C16.2403 5.85117 15.4629 6.62852 14.5011 6.62852C13.5394 6.62852 12.762 5.85117 12.762 4.88939C12.762 3.92761 13.5394 3.15026 14.5011 3.15026Z",
    fill: "url(#paint0_linear_5125_30004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 39.7861C30.2491 39.7861 29.6165 35.3931 29.6165 35.3931L29.6052 30.842H19.9384V29.4755H33.4449C33.4449 29.4755 39.9271 30.2106 39.9271 19.9893C39.9271 9.76803 34.2693 10.1305 34.2693 10.1305H30.8927V14.8736C30.8927 14.8736 31.0747 20.5314 25.3252 20.5314H15.7374C15.7374 20.5314 10.3506 20.4443 10.3506 25.7375V34.4896C10.3506 34.4896 9.53272 39.7861 20.1191 39.7861ZM25.4494 36.7256C24.4876 36.7256 23.7103 35.9483 23.7103 34.9865C23.7103 34.0247 24.4876 33.2474 25.4494 33.2474C26.4112 33.2474 27.1885 34.0247 27.1885 34.9865C27.1885 35.9483 26.4112 36.7256 25.4494 36.7256Z",
    fill: "url(#paint1_linear_5125_30004)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5125_30004",
    x1: 3.85826,
    y1: 3.66038,
    x2: 23.6331,
    y2: 23.2379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5125_30004",
    x1: 15.996,
    y1: 16.2321,
    x2: 37.2321,
    y2: 36.3072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5125_30004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.5547828809f869b3320020f1b9812c71.svg";
export { ForwardRef as ReactComponent };